
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PercentIndicator } from "@/mixins/percentIndicatorMixin";
import TradingBotStats from "@/models/TradingBotStats";
import ExchangeMixin from "@/mixins/exchangeMixin";
import TradingBotChipStatusIndicator from "./TradingBotChipStatusIndicator.vue";
import DateFormatter from "@/mixins/dateFormatterMixin";
import TooltipIcon from "@/components/general/TooltipIcon.vue";
import FunctionalityLimitationMixin from "@/mixins/functionalityLimitationMixin";

@Component({
  components: { TradingBotChipStatusIndicator, TooltipIcon },
  mixins: [PercentIndicator, ExchangeMixin, DateFormatter, FunctionalityLimitationMixin],
})
export default class TradingBotChip extends Vue {
  /**
   * 📦 Bot stats that should be displayed in the chip
   */
  @Prop()
  public botStats!: TradingBotStats;
}
